import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { Prompt } from 'react-router-dom';
import { forEach, capitalize, round } from 'lodash';
import { Steps, Col, Row, Modal, Button, notification } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import classnames from 'classnames';
//Components
import Wait4Me from '../../../../components/Wait4Me';
import BreadCrumb from '../../../../components/BreadCrumb';
import MatchingConfigName from './matchingConfigName';
import SelectWatchList from '../../matchingRunInstanceConfig/createOrEdit/watchlist';
import SelectWhiteList from '../../matchingRunInstanceConfig/createOrEdit/whitelist';
//fontawesome
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//actions
import {
  saveNSMatchingConfigToStore,
  getMatchingConfigParametersData,
  postNSCreateMatchingConfig,
  getNSMatchingConfigById,
  putNSUpdateMatchingConfig,
  getNSMatchingConfigRiskIndicatorList
} from '../../../../redux/actions/ns/matchingConfig';

import { getNSGlobalSettingsPageInfo } from '../../../../redux/actions/settings';

import {
  getNSRIWatchListInitiate,
  getNSRIWhiteListInitiate
} from '../../../../redux/actions/ns/runInstance';

import MatchingConfigParams from './matchingConfigParameters';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../constants/globalConstants';

import style from './index.scss';
import { getModuleTypeByResourceCode } from '../../../../util/miscellaneousUtils';
import { ALERT_SOURCE_MAPPING } from '../../../../util/GlobalConstant';
import { hasAttributeValueByAttributeKey } from '../../../../util';

const resourceCode = 'APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG';

const { Step } = Steps;
const { confirm } = Modal;

export class CreateEditMatchingConfiguration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageType: '',
      currentStep: props?.location?.state?.currentStep || 0,
      isNextBtnDisable: true,
      isSaveBtnDisable: false,
      matchingConfigurationParametersData: [],
      valuesChanged: false,
      datafromApi: false,
      configNameValues: {
        name: '',
        description: '',
        sourceIds: '',
        notes: ''
      },
      weightage: {
        Name: 0,
        Date: 0,
        Address: 0
      },
      key: 0,
      activeKey: '0',
      toggleReset: true,
      isReset: false,
      recommandedChecksFlags: {},
      activeTab: {},
      riskIndicatorsData: [],
      resetCount: 0
    };
  }

  handleWindowBeforeUnload = (e) => {
    const confirmationMessage = 'All updates to the parameters will be lost';
    e.returnValue = confirmationMessage;
    return confirmationMessage;
  };

  observeElement = (elem) => {
    let resizeObserver = new ResizeObserver(() => {
      this.setState({ key: Math.random() });
    });

    resizeObserver.observe(elem);
  };

  static getMapableParameters = (parameters) => {
    if (parameters?.[0]?.categoryType) {
      return parameters?.map((tab) => ({
        ...tab,
        parameterList: tab?.parameterList?.map((parameter, i) => ({
          ...parameter,
          key: i,
          score: {
            unique_id: i,
            value:
              parameter?.actualScore?.toFixed(2) ||
              parameter?.recommendedScore?.toFixed(2),
            recomended: {
              [parameter.recommendedScore.toFixed(
                2
              )]: `${parameter.recommendedScore.toFixed(2)}`
            },
            description: parameter.description,
            behaviour: parameter.trend
          }
        }))
      }));
    } else {
      return parameters?.map((ri) => ({
        weight: ri?.weight,
        displayName: ri.parameter.displayName,
        name: ri.parameter.name
      }));
    }
  };

  static getWeightage = (parameters) => {
    if (parameters != undefined)
      return parameters?.reduce(
        (acc, param) => ({
          ...acc,
          [param.categoryType]:
            round(parseFloat(param?.weight)?.toFixed(4) * 100, 2) || 0
        }),
        {}
      );
    else return {};
  };

  componentDidMount() {
    const {
      dispatch,
      matchingConfigurationParameters,
      createUpdateMatchingConfig,
      match
    } = this.props;
    let ar = match?.url?.split('/');

    if (ar != undefined) {
      this.setState({ pageType: ar[ar?.length - 1] });

      if (dispatch) {
        if (ar[ar?.length - 1] !== 'create') {
          dispatch(getNSMatchingConfigById({ id: match?.params?.id }));
        }
      }
      if (ar.includes('edit') || ar.includes('view')) {
        this.setState({ isNextBtnDisable: false });
      }
    }

    if (createUpdateMatchingConfig?.matchingConfigurationName) {
      const data = createUpdateMatchingConfig?.matchingConfigurationName;
      this.setState({
        configNameValues: {
          name: data ? data?.name : '',
          description: data ? data?.description : '',
          sourceIds: data ? data?.sourceIds : '',
          notes: data ? data?.notes : ''
        }
      });
    }

    if (matchingConfigurationParameters) {
      this.setState({
        matchingConfigurationParametersData:
          CreateEditMatchingConfiguration.getMapableParameters(
            matchingConfigurationParameters
          ),
        weightage: CreateEditMatchingConfiguration.getWeightage(
          matchingConfigurationParameters
        )
      });
    }
    const element = document.getElementById('__create__matching__config__');
    element && this.observeElement(element);
  }

  componentDidUpdate(prevProps) {
    const { matchingConfigurationParameters, dispatch, matchingConfigById } =
      this.props;
    if (
      JSON.stringify(prevProps.matchingConfigurationParameters) !==
      JSON.stringify(matchingConfigurationParameters)
    ) {
      this.setState({
        matchingConfigurationParametersData:
          CreateEditMatchingConfiguration.getMapableParameters(
            matchingConfigurationParameters
          ),
        activeTab: CreateEditMatchingConfiguration.getMapableParameters(
          matchingConfigurationParameters
        )?.[0],
        weightage: CreateEditMatchingConfiguration.getWeightage(
          matchingConfigurationParameters
        )
      });
    }
    let beforeUnloadEventListener = false;
    if (this.state.valuesChanged && !beforeUnloadEventListener) {
      beforeUnloadEventListener = true;
      window.addEventListener('beforeunload', this.handleWindowBeforeUnload);
    }
    // When we change the module type to PS from RS, here
    // we are enabling the save button if matchingConfigurationParametersData is available
    // if (
    //   this.state.configNameValues?.sourceIds == '16' &&
    //   this.state.isSaveBtnDisable &&
    //   this.state.matchingConfigurationParametersData?.length
    // ) {
    //   console.log('componentDidUpdate');
    //   this.setState({ isSaveBtnDisable: false });
    // }

    if (
      prevProps.matchingConfigById.data !== matchingConfigById.data &&
      matchingConfigById.data &&
      this.state.pageType !== 'create'
    ) {
      const { watchlist } = matchingConfigById.data;
      if (Array.isArray(watchlist) && watchlist.length > 0) {
        dispatch(
          saveNSMatchingConfigToStore({
            watchListData: watchlist.map((watchlistItem) => watchlistItem.id)
          })
        );
      }
    }

    if (
      prevProps.matchingConfigById.data !== matchingConfigById.data &&
      matchingConfigById.data &&
      this.state.pageType !== 'create'
    ) {
      const { whitelist } = matchingConfigById.data;
      if (Array.isArray(whitelist) && whitelist.length > 0) {
        dispatch(
          saveNSMatchingConfigToStore({
            whiteListData: whitelist.map((whitelistItem) => whitelistItem.id)
          })
        );
      }
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { matchingConfigById } = props;
    if (matchingConfigById?.data != null && !state?.datafromApi) {
      const {
        data: { matchingParameters }
      } = matchingConfigById;
      return {
        datafromApi: true,
        configNameValues: {
          name: matchingConfigById?.data?.name || '',
          description: matchingConfigById?.data?.description || '',
          sourceIds: matchingConfigById?.data?.sourceIds || '',
          notes: matchingConfigById?.data?.notes || ''
        },
        matchingConfigurationParametersData:
          CreateEditMatchingConfiguration.getMapableParameters(
            matchingParameters
          ),
        weightage:
          CreateEditMatchingConfiguration.getWeightage(matchingParameters),
        riskIndicatorsData:
          matchingConfigById?.data?.sourceIds === ALERT_SOURCE_MAPPING.RS
            ? CreateEditMatchingConfiguration.getMapableParameters(
                matchingParameters
              )
            : []
      };
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleWindowBeforeUnload);
  }

  handleConfigNameChange = (name, value) => {
    this.setState({
      configNameValues: {
        ...this.state.configNameValues,
        [name]: value
      },
      valuesChanged: true
    });
  };

  resetState = () => {
    const { matchingConfigurationParameters } = this.props;
    const s = {
      matchingConfigurationParametersData:
        CreateEditMatchingConfiguration.getMapableParameters(
          matchingConfigurationParameters
        ),
      weight: CreateEditMatchingConfiguration.getWeightage(
        matchingConfigurationParameters
      ),
      configNameValues: {
        name: '',
        description: '',
        sourceIds: '',
        notes: ''
      },
      currentStep: 0,
      isNextBtnDisable: true,
      toggleReset: true,
      valuesChanged: false
    };
    return s;
  };

  saveMatchingConfigToStore = (key, value, isValidationPassed) => {
    const { dispatch, watchListData, whiteListData, authentication } =
      this.props;
    const isRs = hasAttributeValueByAttributeKey(
      authentication,
      'APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG',
      'PRODUCT_SOURCE_ID',
      ALERT_SOURCE_MAPPING.RS
    );
    const { data: watchlistDataSource } = watchListData;
    const { data: whitelistDataSource } = whiteListData;

    if (isValidationPassed) {
      if (dispatch) dispatch(saveNSMatchingConfigToStore({ [key]: value }));

      if (
        dispatch &&
        key === 'watchListData' &&
        Array.isArray(value) &&
        value.length > 0
      ) {
        dispatch(
          saveNSMatchingConfigToStore({
            [key]: value.map((item) => {
              return watchlistDataSource[item - 1]?.id;
            })
          })
        );
      }

      if (
        dispatch &&
        key === 'whiteListData' &&
        Array.isArray(value) &&
        value.length > 0
      ) {
        dispatch(
          saveNSMatchingConfigToStore({
            [key]: value.map((item) => {
              return whitelistDataSource[item - 1]?.id;
            })
          })
        );
      }

      if (key === 'watchListData' && Array.isArray(value) && value.length > 0) {
        this.setState({ isNextBtnDisable: false });
      } else if (key === 'watchListData' && isRs) {
        this.setState({ isNextBtnDisable: false });
      } else if (key === 'watchListData') {
        this.setState({ isNextBtnDisable: true });
      }
      this.setState({ isNextBtnDisable: false });
      this.setState({ toggleReset: false });
    } else {
      if (dispatch && (key === 'watchListData' || key === 'whiteListData')) {
        dispatch(
          saveNSMatchingConfigToStore({
            [key]: []
          })
        );

        if (key === 'watchListData' && !isRs) {
          this.setState({ isNextBtnDisable: true });
        }
      } else {
        this.setState({ isNextBtnDisable: true });
        //this.setState({ toggleReset: true });
      }
    }
  };

  prev = () => {
    const { currentStep } = this.state;
    const { apiActions, authentication } = this.props;
    const isRs = hasAttributeValueByAttributeKey(
      authentication,
      'APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG',
      'PRODUCT_SOURCE_ID',
      ALERT_SOURCE_MAPPING.RS
    );
    const { getNSGlobalSettingsPageInfo: getNSGlobalSettings } = apiActions;
    this.setState(
      { currentStep: this.state.currentStep - 1, isNextBtnDisable: false },
      () => {
        if (currentStep - 1 === 1) {
          if (isRs) {
            getNSGlobalSettings({ pageId: 'NS_IAD_WHITELIST' });
          } else {
            getNSGlobalSettings({ pageId: 'NS_IAD_WATCHLISTS' });
          }
        } else if (currentStep - 1 === 2) {
          if (!isRs) {
            getNSGlobalSettings({ pageId: 'NS_IAD_WHITELIST' });
          }
        }
      }
    );
  };

  next = () => {
    const {
      apiActions,
      dispatch,
      createUpdateMatchingConfig,
      match,
      authentication
    } = this.props;
    const isRs = hasAttributeValueByAttributeKey(
      authentication,
      'APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG',
      'PRODUCT_SOURCE_ID',
      ALERT_SOURCE_MAPPING.RS
    );
    const { getNSGlobalSettingsPageInfo: getNSGlobalSettings } = apiActions;

    if (createUpdateMatchingConfig) {
      if (this.state.currentStep === 0) {
        if (isRs) {
          getNSGlobalSettings({ pageId: 'NS_IAD_WHITELIST' });
          this.setState({ currentStep: this.state.currentStep + 1 });
        } else {
          const { watchListData } = createUpdateMatchingConfig;
          const isEnableNextButton =
            Array.isArray(watchListData) && watchListData.length > 0;

          getNSGlobalSettings({ pageId: 'NS_IAD_WATCHLISTS' });
          this.setState({
            currentStep: this.state.currentStep + 1,
            isNextBtnDisable: !isEnableNextButton
          });
        }
      } else if (this.state.currentStep === 1) {
        if (!isRs) {
          getNSGlobalSettings({ pageId: 'NS_IAD_WHITELIST' });
        }
        this.setState({ currentStep: this.state.currentStep + 1 });
      }

      if (this.state.currentStep === 2) {
        this.setState({ currentStep: this.state.currentStep + 1 });
      }

      if (dispatch && this.state.pageType) {
        if (this.state.pageType !== 'create') {
          // dispatch(getNSMatchingConfigById({ id: match?.params?.id }));
        } else {
          if (
            this.state.configNameValues.sourceIds !== ALERT_SOURCE_MAPPING.RS
          ) {
            dispatch(getMatchingConfigParametersData());
          }
        }
      } else {
        console.log('add notification any errors');
      }
    }
  };

  routeHandlder = (path, param) => {
    const { navigateTo } = this.props.apiActions;
    if (navigateTo) {
      navigateTo(path, param);
    }
  };

  handleConfigParam = (data) => {
    this.setState({
      matchingConfigurationParametersData: [...data],
      valuesChanged: true,
      toggleReset: false
    });
  };

  handleReset = () => {
    const { currentStep, pageType, resetCount } = this.state;
    const {
      dispatch,
      matchingConfigurationParameters,
      matchingConfigById,
      createUpdateMatchingConfig,
      authentication
    } = this.props;
    const isRs = hasAttributeValueByAttributeKey(
      authentication,
      'APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG',
      'PRODUCT_SOURCE_ID',
      ALERT_SOURCE_MAPPING.RS
    );

    switch (currentStep) {
      case 0:
        if (pageType == 'edit' && matchingConfigById?.data) {
          const data = matchingConfigById?.data;
          this.setState({
            configNameValues: {
              name: data ? data?.name : '',
              description: data ? data?.description : '',
              sourceIds: data ? data?.sourceIds : '',
              notes: data ? data?.notes : ''
            },
            resetCount: resetCount + 1
          });
        } else {
          this.setState({
            configNameValues: {
              name: '',
              description: '',
              sourceIds: '',
              notes: ''
            },
            isNextBtnDisable: true,
            valuesChanged: false,
            resetCount: resetCount + 1
          });
        }

        if (dispatch)
          dispatch(
            saveNSMatchingConfigToStore({
              matchingConfigurationName: null,
              matchingConfigurationParameters: null
            })
          );
        break;

      case 1:
        if (dispatch) {
          if (isRs) {
            if (pageType == 'edit' && matchingConfigById?.data) {
              const { whitelist } = matchingConfigById.data;
              dispatch(
                saveNSMatchingConfigToStore({
                  whiteListData: whitelist.map(
                    (whitelistItem) => whitelistItem.id
                  )
                })
              );
            } else {
              dispatch(
                saveNSMatchingConfigToStore({
                  whiteListData: []
                })
              );
            }
          } else {
            if (pageType == 'edit' && matchingConfigById?.data) {
              const { watchlist } = matchingConfigById.data;
              dispatch(
                saveNSMatchingConfigToStore({
                  watchListData: watchlist.map(
                    (watchlistItem) => watchlistItem.id
                  )
                })
              );
            } else {
              dispatch(
                saveNSMatchingConfigToStore({
                  watchListData: []
                })
              );
            }
          }
        }
        break;
      case 2:
        if (isRs) {
          if (
            this.state.configNameValues.sourceIds === ALERT_SOURCE_MAPPING.RS
          ) {
            let riskIndicators = this.state.riskIndicatorsData;
            riskIndicators.forEach((ri) => {
              ri.weight = null;
            });
            this.setState({
              riskIndicatorsData: riskIndicators,
              resetCount: resetCount + 1,
              isSaveBtnDisable: true
            });
          }
          this.setState({
            matchingConfigurationParametersData:
              CreateEditMatchingConfiguration.getMapableParameters(
                matchingConfigurationParameters
              ),
            weightage: CreateEditMatchingConfiguration.getWeightage(
              matchingConfigurationParameters
            ),
            isSaveBtnDisable: true,
            key: Math.random(),
            resetCount: resetCount + 1
          });
          if (dispatch)
            dispatch(
              saveNSMatchingConfigToStore({
                weightageError: null
              })
            );
        } else {
          if (dispatch) {
            if (pageType == 'edit' && matchingConfigById?.data) {
              const { whitelist } = matchingConfigById.data;
              dispatch(
                saveNSMatchingConfigToStore({
                  whiteListData: whitelist.map(
                    (whitelistItem) => whitelistItem.id
                  )
                })
              );
            } else {
              dispatch(
                saveNSMatchingConfigToStore({
                  whiteListData: []
                })
              );
            }
          }
        }
        break;
      case 3:
        if (this.state.configNameValues.sourceIds === ALERT_SOURCE_MAPPING.RS) {
          let riskIndicators = this.state.riskIndicatorsData;
          riskIndicators.forEach((ri) => {
            ri.weight = null;
          });
          this.setState({ riskIndicatorsData: riskIndicators });
        }
        this.setState({
          matchingConfigurationParametersData:
            CreateEditMatchingConfiguration.getMapableParameters(
              matchingConfigurationParameters
            ),
          weightage: CreateEditMatchingConfiguration.getWeightage(
            matchingConfigurationParameters
          ),
          isSaveBtnDisable: false,
          key: Math.random(),
          resetCount: resetCount + 1
        });
        if (dispatch)
          dispatch(
            saveNSMatchingConfigToStore({
              weightageError: null
            })
          );
        break;
      default:
        break;
    }
    this.setRecommandedChecksFlags({});
    this.setState({ isReset: true, resetCount: resetCount + 1 });
    // this.setState({ toggleReset: true });
  };

  childReset = (value) => {
    this.setState({ isReset: value });
  };

  showResetConfirm = () => {
    const { pageType } = this.state;
    confirm({
      title: 'Do you want to reset parameters?',
      icon: <ExclamationCircleOutlined />,
      content:
        pageType == 'edit'
          ? 'All parameters on this page will be reverted to their last saved values.'
          : 'All parameters on this page will be reverted to their default values.',
      onOk: () => {
        this.handleReset();
      },
      onCancel: () => {
        console.log('Cancel');
      },
      okText: 'Reset'
    });
  };

  showCancelConfirm = () => {
    if (!this.state.valuesChanged) {
      this.routeHandlder(`${ROUTE_AMLS_SMART_SCREENING}/matchingConfig`);
      return;
    }
    confirm({
      title: 'Do you want to cancel changes?',
      icon: <ExclamationCircleOutlined />,
      content:
        this.state.currentStep === 0
          ? 'All the details entered by you will be lost.'
          : 'Changes done in any Parameters will be reverted back to the data saved in the previous edit.',
      onOk: () => {
        this.setState(
          {
            ...this.resetState()
          },
          () =>
            this.routeHandlder(`${ROUTE_AMLS_SMART_SCREENING}/matchingConfig`)
        );
      },
      onCancel: () => {
        console.log('Cancel');
      }
    });
  };

  geAPIRequestFormattedTunningParameters = () => {
    const { matchingConfigurationParametersData, weightage } = this.state;
    let ar = [];

    let sampleResponseObject = {
      categoryType: '',
      weight: '',
      parameterList: []
    };

    matchingConfigurationParametersData.forEach((categoryObj) => {
      sampleResponseObject['categoryType'] = categoryObj.categoryType;
      sampleResponseObject['weight'] =
        parseFloat(weightage[categoryObj.categoryType]) / 100;
      forEach(categoryObj.parameterList, (ele) => {
        let o = {
          name: ele.name,
          displayName: ele.displayName,
          description: ele.description,
          actualScore: parseFloat(ele.score.value),
          recommendedScore: ele.recommendedScore,
          increment: ele.increment,
          minValue: ele.minValue,
          maxValue: ele.maxValue,
          trend: ele.trend
        };
        sampleResponseObject.parameterList.push(o);
      });
      ar.push(sampleResponseObject);
      sampleResponseObject = {
        categoryType: '',
        weight: '',
        parameterList: []
      };
    });

    return JSON.stringify(ar);
  };

  getAPIformattedRiskIndicatorParameters = () => {
    const { riskIndicatorsData } = this.state;
    const data = [];
    const returnSaveDataRiskIndicators = riskIndicatorsData.map((indicator) => {
      return {
        parameter: {
          displayName: indicator.displayName,
          name: indicator.name
        },
        weight: indicator.weight
      };
    });
    data.push(...returnSaveDataRiskIndicators);
    return JSON.stringify(data);
  };

  handleSave = () => {
    confirm({
      title: 'Do you want to save changes?',
      icon: <ExclamationCircleOutlined />,
      content: 'Updates to the parameter thresholds will be saved.',
      okText: 'Save',
      onOk: () => {
        const { configNameValues } = this.state;
        const { dispatch, match, createUpdateMatchingConfig } = this.props;
        const { watchListData, whiteListData } = createUpdateMatchingConfig;
        let {
          params: { id },
          url
        } = match;
        let ar = url.split('/');

        this.setState({ valuesChanged: false }, () => {
          let param = {
            ...configNameValues,
            tuningParameters:
              this.state.configNameValues.sourceIds === ALERT_SOURCE_MAPPING.RS
                ? this.getAPIformattedRiskIndicatorParameters()
                : this.geAPIRequestFormattedTunningParameters(),
            watchlistIds: watchListData
              ? watchListData.map((id) => String(id))
              : [],
            whitelistIds: whiteListData
              ? whiteListData.map((id) => String(id))
              : []
          };
          if (dispatch) {
            if (ar.includes('edit')) {
              param['id'] = id;
              dispatch(putNSUpdateMatchingConfig(param));
            } else {
              dispatch(postNSCreateMatchingConfig(param));
            }
          }
        });
      },
      onCancel: () => {
        console.log('Cancel');
      }
    });
  };

  handleDone = () => {
    this.props.apiActions.navigateTo(
      ROUTE_AMLS_SMART_SCREENING + '/MatchingConfig'
    );
  };

  renderStepsButton = (steps) => {
    const { currentStep, isNextBtnDisable, isSaveBtnDisable, pageType } =
      this.state;
    const { createUpdateMatchingConfig, match } = this.props;

    return (
      <div className={style.stepsAction}>
        {currentStep > 0 && (
          <button
            id={'matchingConfigurationName-backBtn'}
            className={style.btn}
            style={{ margin: '0 8px' }}
            onClick={this.prev}>
            Back
          </button>
        )}
        {pageType !== 'view' ? (
          <React.Fragment>
            <button
              id={'matchingConfigurationName-cancelBtn'}
              className={style.btn}
              style={{ margin: '0 8px' }}
              onClick={this.showCancelConfirm}>
              Cancel
            </button>
            <button
              disabled={this.state.toggleReset}
              className={style.btn}
              style={{ margin: '0 8px' }}
              onClick={this.showResetConfirm}>
              Reset All
            </button>
          </React.Fragment>
        ) : (
          <button
            id={'matchingConfigurationName-editBtn'}
            className={style.btn}
            style={{ margin: '0 8px' }}
            onClick={() => {
              this.setState({ pageType: 'edit' });
              this.routeHandlder(
                `${ROUTE_AMLS_SMART_SCREENING}/MatchingConfig/${match?.params?.id}/edit`,
                { currentStep }
              );
            }}>
            Edit
          </button>
        )}
        {currentStep < steps.length - 1 && (
          <button
            id={'matchingConfigurationName-nextBtn'}
            className={classnames(style.btn, style.btnPrimary)}
            style={{ margin: '0 8px' }}
            onClick={this.next}
            disabled={isNextBtnDisable}>
            Next
          </button>
        )}
        {currentStep === steps.length - 1 &&
          (pageType === 'view' ? (
            <Button
              id={'matchingConfigurationName-saveBtn'}
              type="primary"
              onClick={this.handleDone}
              className={classnames(style.btn, style.btnPrimary)}
              style={{ margin: '0 8px' }}>
              Done
            </Button>
          ) : (
            <Button
              id={'matchingConfigurationName-saveBtn'}
              type="primary"
              onClick={this.handleSave}
              className={classnames(style.btn, style.btnPrimary)}
              style={{ margin: '0 8px' }}
              disabled={isSaveBtnDisable}
              loading={createUpdateMatchingConfig?.isLoading}>
              Save
            </Button>
          ))}
      </div>
    );
  };

  handleChangeWeightage = (name, value, isValid) => {
    const { weightage } = this.state;
    this.setState({
      weightage: { ...weightage, [name]: value },
      isSaveBtnDisable: !isValid
    });
  };

  setActiveKey = (k) => {
    this.setState({ activeKey: k });
  };

  handleOnBlur = () => {
    this.setState({ valuesChanged: true });
  };

  setRecommandedChecksFlags = (obj) => {
    this.setState({ recommandedChecksFlags: obj });
  };

  handlesetRiskIndicatorsData = (obj) => {
    this.setState({
      riskIndicatorsData: obj,
      valuesChanged: true,
      toggleReset: false
    });
  };

  handRiskIndicatorsWeightAge = (isValid) => {
    this.setState({ isSaveBtnDisable: !isValid });
  };

  fetchRiskIndicators = () => {
    const { dispatch } = this.props;
    dispatch(getNSMatchingConfigRiskIndicatorList());
  };

  render() {
    const {
      currentStep,
      valuesChanged,
      matchingConfigurationParametersData,
      configNameValues,
      weightage,
      key,
      activeKey,
      pageType,
      recommandedChecksFlags,
      activeTab
    } = this.state;
    const {
      createUpdateMatchingConfig,
      matchingConfigById,
      authentication,
      handlesetRiskIndicatorsData
    } = this.props;
    const { resetCount } = this.state;

    const isRs = hasAttributeValueByAttributeKey(
      authentication,
      'APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG',
      'PRODUCT_SOURCE_ID',
      ALERT_SOURCE_MAPPING.RS
    );
    let steps = [
      {
        title: 'Matching Configuration Name',
        content:
          matchingConfigById?.isLoading &&
          (pageType === 'view' || pageType == 'edit') ? (
            <div className={style.loadingWrapper}>
              <Wait4Me />
            </div>
          ) : (
            <MatchingConfigName
              modulesList={getModuleTypeByResourceCode(
                authentication,
                resourceCode
              )}
              saveMatchingConfigToStore={this.saveMatchingConfigToStore}
              data={createUpdateMatchingConfig?.matchingConfigurationName}
              handleSubmit={this.next}
              values={configNameValues}
              handleChange={this.handleConfigNameChange}
              reset={this.state.isReset}
              childReset={this.childReset}
              handleOnBlur={this.handleOnBlur}
              disabled={pageType == 'view'}
              disabledDropDown={this.state.pageType !== 'create'}
            />
          )
      },
      {
        title: 'Select Watchlist',
        content: (
          <div>
            <SelectWatchList
              {...this.props}
              pageType={pageType}
              tableData={this.props?.watchListData}
              selectedRowKeysDataFromProps={
                createUpdateMatchingConfig?.watchListData
              }
              saveMatchingConfigToStore={this.saveMatchingConfigToStore}
            />
          </div>
        )
      },
      {
        title: 'Select Whitelist',
        content: (
          <SelectWhiteList
            {...this.props}
            pageType={pageType}
            tableData={this.props?.whiteListData}
            selectedRowKeysDataFromProps={
              createUpdateMatchingConfig?.whiteListData
            }
            saveMatchingConfigToStore={this.saveMatchingConfigToStore}
          />
        )
      },
      {
        title: 'Matching Configuration Parameters',
        content: (
          <MatchingConfigParams
            resetCountRI={resetCount}
            configNameValues={configNameValues}
            saveMatchingConfigToStore={this.saveMatchingConfigToStore}
            data={matchingConfigurationParametersData}
            handleChange={this.handleConfigParam}
            handleChangeWeightage={this.handleChangeWeightage}
            weightage={weightage}
            activeKey={activeKey}
            setActiveKey={this.setActiveKey}
            weightageErrorFromStore={createUpdateMatchingConfig?.weightageError}
            disabled={pageType === 'view'}
            recommandedChecksFlags={recommandedChecksFlags}
            setRecommandedChecksFlags={this.setRecommandedChecksFlags}
            activeTab={activeTab}
            setActiveTab={(obj) => this.setState({ activeTab: obj })}
            riskIndicatorsState={this.props.riskIndicators}
            riskIndicatorsData={this.state.riskIndicatorsData}
            setRiskIndicatorData={this.handlesetRiskIndicatorsData}
            handRiskIndicatorsWeightAge={this.handRiskIndicatorsWeightAge}
            fetchRiskIndicators={this.fetchRiskIndicators}
          />
        )
      }
    ];

    let stepsRS = [
      {
        title: 'Matching Configuration Name',
        content:
          matchingConfigById?.isLoading &&
          (pageType === 'view' || pageType == 'edit') ? (
            <div className={style.loadingWrapper}>
              <Wait4Me />
            </div>
          ) : (
            <MatchingConfigName
              modulesList={getModuleTypeByResourceCode(
                authentication,
                resourceCode
              )}
              saveMatchingConfigToStore={this.saveMatchingConfigToStore}
              data={createUpdateMatchingConfig?.matchingConfigurationName}
              handleSubmit={this.next}
              values={configNameValues}
              handleChange={this.handleConfigNameChange}
              reset={this.state.isReset}
              childReset={this.childReset}
              handleOnBlur={this.handleOnBlur}
              disabled={pageType == 'view'}
              disabledDropDown={this.state.pageType !== 'create'}
            />
          )
      },
      {
        title: 'Select Whitelist',
        content: (
          <SelectWhiteList
            {...this.props}
            tableData={this.props?.whiteListData}
            selectedRowKeysDataFromProps={
              createUpdateMatchingConfig?.whiteListData
            }
            saveMatchingConfigToStore={this.saveMatchingConfigToStore}
          />
        )
      },
      {
        title: 'Matching Configuration Parameters',
        content: (
          <MatchingConfigParams
            configNameValues={configNameValues}
            saveMatchingConfigToStore={this.saveMatchingConfigToStore}
            data={matchingConfigurationParametersData}
            handleChange={this.handleConfigParam}
            handleChangeWeightage={this.handleChangeWeightage}
            weightage={weightage}
            activeKey={activeKey}
            setActiveKey={this.setActiveKey}
            weightageErrorFromStore={createUpdateMatchingConfig?.weightageError}
            disabled={pageType === 'view'}
            recommandedChecksFlags={recommandedChecksFlags}
            setRecommandedChecksFlags={this.setRecommandedChecksFlags}
            activeTab={activeTab}
            setActiveTab={(obj) => this.setState({ activeTab: obj })}
            riskIndicatorsState={this.props.riskIndicators}
            riskIndicatorsData={this.state.riskIndicatorsData}
            setRiskIndicatorData={this.handlesetRiskIndicatorsData}
            handRiskIndicatorsWeightAge={this.handRiskIndicatorsWeightAge}
            fetchRiskIndicators={this.fetchRiskIndicators}
            resetCountRI={resetCount}
          />
        )
      }
    ];

    //when user has added something than we'll show prompt **pending**

    return (
      <Row id="__create__matching__config__">
        <Prompt
          when={valuesChanged}
          message={(location) => {
            return location.pathname.startsWith('/login')
              ? true
              : `Changes you made may not be saved.`;
          }}
        />
        <Col span={24}>
          <div className={style.wrapper}>
            <div className={style.head}>
              <BreadCrumb
                crumbs={[
                  {
                    label: 'Matching Configuration',
                    linkTo: `${ROUTE_AMLS_SMART_SCREENING}/matchingConfig`
                  },
                  { label: `${capitalize(pageType)} Matching Configuration` }
                ]}
              />
              <div className={style.head_content} id="matchingConfig-head">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    id="matchingConfig-head-backbtn"
                    onClick={() => {
                      if (currentStep === 0)
                        this.routeHandlder(
                          `${ROUTE_AMLS_SMART_SCREENING}/matchingConfig`
                        );
                      else this.setState({ currentStep: 0 });
                    }}
                    style={{ cursor: 'pointer' }}>
                    <FontAwesomeIcon icon={faArrowLeft} color={'#000'} />
                  </div>
                  <h4>{capitalize(pageType)} Matching Configuration</h4>
                </div>
              </div>
            </div>
            <div className={style.tabContent}>
              <Steps current={currentStep} style={{ width: '100%' }}>
                {/* render RS steps */}
                {isRs &&
                  stepsRS.map((item, idx) => (
                    <Step key={idx} title={item?.title} />
                  ))}

                {/* render normal steps if not RS */}
                {!isRs &&
                  steps.map((item, idx) => (
                    <Step key={idx} title={item?.title} />
                  ))}
              </Steps>
              <div className={style.stepsContent}>
                {isRs && stepsRS[currentStep].content}
                {!isRs && steps[currentStep].content}
              </div>
              {this.renderStepsButton(isRs ? stepsRS : steps)}
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    createUpdateMatchingConfig: state.nsMatchingConfig.createUpdate,
    matchingConfigurationParameters:
      state.nsMatchingConfig.matchingConfigurationParameters.data,
    isLoading: state.app.isFetching,
    matchingConfigById: state.nsMatchingConfig.matchingConfigById,
    watchListData: state.nsRunInstanceConfig.watchList,
    whiteListData: state.nsRunInstanceConfig.whiteList,
    riskIndicators: state.nsRiskIndicators.riskIndicators.data,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path, param) => dispatch(push(path, param)),
        getNSGlobalSettingsPageInfo,
        getNSRIWatchListInitiate,
        getNSRIWhiteListInitiate
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditMatchingConfiguration);
